import type { AxiosRequestConfig } from 'axios';
import type { AxiosError } from 'axios';
import { backendClient } from '../BackendApiClient';

/**
 * Custom mutator for Orval-generated API client.
 * Uses backendClient to inherit auth, correlation ID, error handling, and ERP headers.
 * Returns response data directly (not AxiosResponse) for use with React Query.
 */
export const customInstance = async <T>(config: AxiosRequestConfig): Promise<T> => {
  const response = await backendClient.request<T>(config);
  return response.data;
};

/** For React Query / SWR error typing */
export type ErrorType<Error> = AxiosError<Error>;

/** Body type passthrough */
export type BodyType<BodyData> = BodyData;
